import { render, staticRenderFns } from "./UploadFilesStep2.vue?vue&type=template&id=f2ba4fba&scoped=true&"
import script from "./UploadFilesStep2.vue?vue&type=script&lang=js&"
export * from "./UploadFilesStep2.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesStep2.vue?vue&type=style&index=0&id=f2ba4fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ba4fba",
  null
  
)

export default component.exports